import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import moment from "moment";
import {
  Button,
  DialogActions,
  Divider,
  Grid,
  Stack,
  Typography,
  Card,
  CardMedia,
  CardContent,
  Avatar,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import { CircularProgress } from "@mui/material";
import { useMutation } from "react-query";
import { updatePic } from "app/services/management";
import { Box } from "@mui/material";
import { getSchoolProfile } from "app/services/management";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
import DialogHeader from "app/components/common/DialogHeader";
import { LoadingButton } from "@mui/lab";
import dayjs from "dayjs";
import { Edit } from "@mui/icons-material";
import { Helmet } from "react-helmet";
import { queryClient } from "App";
import UpdateSchoolProfileDiaolog from "app/components/common/Dialogs/school/UpdateSchoolProfileDiaolog";
import useFolderWiseFileUploader from "app/hooks/upload/useFolderWiseFileUploader";
import { ValidateFileSize } from "app/utils/helper";
const InfoRow = ({ label, value }) => (
  <Box sx={{ mb: 1.5 }}>
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{ fontSize: "0.875rem", display: "block" }}
    >
      {label}
    </Typography>
    <Typography
      variant="body2"
      fontWeight={600}
      color="primary.dark"
      sx={{ fontSize: "1.25rem", wordBreak: "break-word" }}
    >
      {value || "--"}
    </Typography>
  </Box>
);

const SchoolProfileChild = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [open, setOpen] = useState(false);
  const [openUploadDialog, setOpenUploadDialog] = useState(false);
  const [schoolProfile, setSchoolProfile] = useState();
  const [signature, setSignature] = useState({
    dialog: false,
    localPic: "",
    loading: false,
  });

  const { mutate: uploadPicture, isLoading: isLoadingPic } = useMutation(
    updatePic,
    {
      onSuccess: ({ data }) => {
        toast.success(data?.message);
        queryClient.invalidateQueries({ queryKey: ["getSchoolProfile"] });
        setOpenUploadDialog(false);
        setSignature((prev) => ({
          ...prev,
          loading: false,
          localPic: "",
          dialog: false,
        }));
      },
      onError: (error) => {
        toast.error(error.response.data?.message);
      },
    }
  );
  const { handleUploadImage } = useFolderWiseFileUploader();

  const handleUploadSignature = async () => {
    setSignature((prev) => ({ ...prev, loading: true }));
    if (signature.localPic) {
      // Validate file size before uploading
      const { valid, message } = ValidateFileSize(signature.localPic, {
        validateImage: true,
        imageLimit: 0.5 * 1048576, // 0.5 MB
      });
      if (!valid) {
        toast.error(message);
        setSignature((prev) => ({ ...prev, loading: false }));
        return;
      }

      let attachmentUrl = await handleUploadImage(
        true,
        signature.localPic,
        "withSession",
        "SCHOOL_PROFILE",
        "SIGNATURE"
      );

      uploadPicture({ signatureForIdCard: attachmentUrl?.fileURL });
    }
    setSignature((prev) => ({ ...prev, loading: false }));
  };

  const { isLoading: loadingSchoolProfile, isFetching } = useQuery({
    queryKey: ["getSchoolProfile"],
    queryFn: () => getSchoolProfile(),
    onSuccess: ({ data }) => {
      setSchoolProfile(data?.obj);
    },
    onError: (data) => {
      toast.error(data?.response?.data?.message);
    },
  });

  return (
    <>
      <Dialog
        open={signature.dialog}
        onClose={() =>
          setSignature((prev) => ({
            ...prev,
            dialog: false,
            localPic: false,
            loading: false,
          }))
        }
        maxWidth="xs"
        fullWidth
      >
        <DialogHeader
          title="Digital Signature"
          handleClose={() =>
            setSignature((prev) => ({
              ...prev,
              dialog: false,
              localPic: false,
              loading: false,
            }))
          }
        />
        <DialogContent>
          <Box sx={{ my: 1 }}>
            {signature.localPic && (
              <Box
                sx={{
                  width: "100%",
                  maxWidth: "220px",
                  height: "70px",
                  bgcolor: "rgba(208, 208, 226, 0.2)",
                  border: "1px solid #B6C8D6",
                  borderRadius: 1,
                  p: 0.5,
                  mb: 2,
                }}
              >
                <img
                  src={URL.createObjectURL(signature.localPic)}
                  alt="ekalsutra-digital-signature"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </Box>
            )}
          </Box>
          <Box>
            <input
              type="file"
              accept="image/*"
              onChange={(e) =>
                setSignature((prev) => ({
                  ...prev,
                  localPic: e.target.files[0],
                }))
              }
            />
          </Box>
        </DialogContent>
        <Divider />
        <DialogActions>
          <LoadingButton
            loading={signature.loading || isLoadingPic}
            variant="contained"
            color="secondary"
            onClick={handleUploadSignature}
          >
            Upload
          </LoadingButton>
        </DialogActions>
      </Dialog>

      {/* Update school profile dialog */}
      <UpdateSchoolProfileDiaolog
        open={open}
        onClose={() => setOpen(false)}
        data={schoolProfile}
      />

      <Helmet>
        <title>School Profile</title>
      </Helmet>

      <Box sx={{mb: isMobile ? 12 : 0}}>
        {(loadingSchoolProfile || isFetching) && (
          <Stack direction="row" justifyContent="center" sx={{ py: 2 }}>
            <CircularProgress />
          </Stack>
        )}

        <Card elevation={2} sx={{ overflow: "hidden", borderRadius: 4 }}>
          {/* Cover Photo Section */}
          <CardMedia
            component="img"
            height="180"
            image={schoolProfile?.coverPhoto || "/banner-placeholder.png"}
            alt="School Cover"
            sx={{ objectFit: "cover" }}
          />

          {/* Logo and Edit Button */}
          <Box sx={{ position: "relative", mt: -5, textAlign: "center" }}>
            <Avatar
              src={schoolProfile?.schoolLogo || "/image-placeholder.jpeg"}
              alt="School Logo"
              sx={{
                width: 80,
                height: 80,
                border: "4px solid white",
                boxShadow: 2,
                mx: "auto",
                bgcolor: "background.paper",
              }}
            />
            <IconButton
              onClick={() => setOpen(true)}
              size="small"
              sx={{
                position: "absolute",
                bottom: 0,
                left: "50%",
                transform: "translateX(10px)",
                bgcolor: "primary.main",
                color: "white",
                "&:hover": { bgcolor: "primary.dark" },
                width: 28,
                height: 28,
              }}
            >
              <Edit sx={{ fontSize: 16 }} />
            </IconButton>
          </Box>

          <CardContent sx={{ pt: 1, pb: 2 }}>
            {/* School Name */}
            <Typography
              variant="h5"
              textAlign="center"
              gutterBottom
            >
              {schoolProfile?.schoolName}
            </Typography>

            <Divider sx={{ my: 2 }} />

            {/* Information Grid */}
            <Grid container spacing={2}>
              <Grid item xs={6} sm={4} md={3}>
                <InfoRow
                  label="School Initial"
                  value={schoolProfile?.schoolInitials}
                />
              </Grid>

              <Grid item xs={6} sm={4} md={3}>
                <InfoRow
                  label="Education Type"
                  value={schoolProfile?.educationType}
                />
              </Grid>

              <Grid item xs={6} sm={4} md={3}>
                <InfoRow
                  label="Registration Number"
                  value={schoolProfile?.schoolRegisterNumber}
                />
              </Grid>

              <Grid item xs={6} sm={4} md={3}>
                <InfoRow
                  label="Registration Date"
                  value={
                    schoolProfile?.schoolRegisterDate
                      ? moment(schoolProfile.schoolRegisterDate).format(
                          "DD-MM-YYYY"
                        )
                      : null
                  }
                />
              </Grid>

              <Grid item xs={12} sm={8} md={6}>
                <InfoRow
                  label="School Address"
                  value={
                    schoolProfile?.schoolAddress
                      ? `${schoolProfile.schoolAddress.address}, ${schoolProfile.schoolAddress.dist}, ${schoolProfile.schoolAddress.state} (${schoolProfile.schoolAddress.pinCode})`
                      : null
                  }
                />
              </Grid>

              <Grid item xs={6} sm={4} md={3}>
                <InfoRow
                  label="Affiliated By"
                  value={schoolProfile?.affiliatedTo}
                />
              </Grid>

              <Grid item xs={6} sm={4} md={3}>
                <InfoRow
                  label="Affiliation Number"
                  value={schoolProfile?.affiliationNumber}
                />
              </Grid>

              <Grid item xs={6} sm={4} md={3}>
                <InfoRow
                  label="Affiliation Upto"
                  value={
                    schoolProfile?.affiliationUpTo
                      ? dayjs(schoolProfile.affiliationUpTo).format(
                          "DD-MM-YYYY"
                        )
                      : null
                  }
                />
              </Grid>

              <Grid item xs={6} sm={4} md={3}>
                <InfoRow
                  label="Establishment Date"
                  value={
                    schoolProfile?.establishmentDate
                      ? dayjs(schoolProfile.establishmentDate).format(
                          "DD-MM-YYYY"
                        )
                      : null
                  }
                />
              </Grid>

              <Grid item xs={6} sm={4} md={3}>
                <InfoRow label="Email Address" value={schoolProfile?.email} />
              </Grid>

              <Grid item xs={6} sm={4} md={3}>
                <InfoRow
                  label="Contact Number"
                  value={schoolProfile?.schoolContactNumber}
                />
              </Grid>

              <Grid item xs={6} sm={4} md={3}>
                <InfoRow
                  label="Mobile Number"
                  value={schoolProfile?.mobileNumber}
                />
              </Grid>

              <Grid item xs={6} sm={4} md={3}>
                <InfoRow
                  label="School Website"
                  value={schoolProfile?.website}
                />
              </Grid>

              <Grid item xs={6} sm={4} md={3}>
                <InfoRow label="GST Number" value={schoolProfile?.gstNumber} />
              </Grid>

              <Grid item xs={6} sm={4} md={3}>
                <InfoRow label="UDISE Code" value={schoolProfile?.udiseCode} />
              </Grid>

              <Grid item xs={6} sm={4} md={3}>
                <InfoRow
                  label="License Number"
                  value={schoolProfile?.ekalRefNumber}
                />
              </Grid>

              <Grid item xs={6} sm={4} md={3}>
                <InfoRow
                  label="License Date"
                  value={
                    schoolProfile?.licenseDate
                      ? dayjs(schoolProfile.licenseDate).format("DD-MM-YYYY")
                      : null
                  }
                />
              </Grid>
            </Grid>

            <Divider sx={{ my: 2 }} />

            {/* Digital Signature Section */}
            <Box>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ fontSize: "0.75rem", display: "block", mb: 1 }}
              >
                Signature For ID Card
              </Typography>
              <Stack
                direction="row"
                gap={2}
                alignItems="center"
                flexWrap="wrap"
              >
                {schoolProfile?.signatureForIdCard && (
                  <Box
                    sx={{
                      width: 220,
                      height: 70,
                      bgcolor: "rgba(208, 208, 226, 0.2)",
                      border: "1px solid #B6C8D6",
                      borderRadius: 2,
                      p: 0.5,
                    }}
                  >
                    <img
                      src={schoolProfile?.signatureForIdCard}
                      alt="ekalsutra-principal-signature"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </Box>
                )}
                <Button
                  onClick={() =>
                    setSignature((prev) => ({ ...prev, dialog: true }))
                  }
                  variant="outlined"
                  color="secondary"
                  size="small"
                >
                  {schoolProfile?.signatureForIdCard
                    ? "Change Signature"
                    : "Add Digital Signature"}
                </Button>
              </Stack>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

export default SchoolProfileChild;
